import { TRANSLATIONS, TRANSLATIONS_FORMAT, LOCALE_ID, InjectionToken } from '@angular/core';
import { getFile } from './provider.helper';
import { mergeXlf, getXMLParser } from './xlf.merger';
import { loadTranslations, clearTranslations } from '@angular/localize';

function getWindow(): any {
    return window;
}

export declare const TRANSLATIONS_JSON: InjectionToken<any>;
const rootPath = getWindow().SERVER_CONFIG ? getWindow().SERVER_CONFIG.APP_ROOT_PATH : '';

function getTranslationProvider(translations: any, local: string) {
    return [
        { provide: TRANSLATIONS, useValue: translations },
        { provide: TRANSLATIONS_FORMAT, useValue: 'xlf' },
        { provide: LOCALE_ID, useValue: local }
    ];
}

async function getTranslationFile(path: string, errorMessage: string){
    try {
        const result = await getFile(path);
        return result;
    }catch(e){
        console.info(errorMessage);
        return null;
    }
}

export async function xlfTranslationProvider(): Promise<object[]> {
    clearTranslations();
    const local = getWindow().systemLang || 'en';
    const theme = (getWindow().SERVER_CONFIG && getWindow().SERVER_CONFIG.CURRENT_THEME)
        ? getWindow().SERVER_CONFIG.CURRENT_THEME
        : getWindow().systemTheme || 'ClimatixIC';

    const translationFile = rootPath + `local/xlf/messages.${local}.xlf`;
    const defaultThemeTranslationFile = rootPath + `themes/${theme}/translations/translation.xlf`;
    const themeTranslationFile = rootPath + `themes/${theme}/translations/translation.${local}.xlf`;

    let translations;

    const translationRequests: any[] = [
        getTranslationFile(translationFile, 'Translation file not found'),
        getTranslationFile(defaultThemeTranslationFile, 'Default theme transation file not found!'),
        getTranslationFile(themeTranslationFile, 'Theme translation file not found!'),
    ];

    if (theme === 'default') {
        translationRequests.pop();
        translationRequests.pop();
    }

    const translationResults = await Promise.all(translationRequests);

    for(const current of translationResults){
        if(current){
            translations = mergeXlf(translations, current);
        }
    }

    const parser = getXMLParser();
    const parsedTranslations = parser.parseXml(translations as string);
    getWindow().__TRANSLATIONS = parsedTranslations;
    loadExternalTranslations(parsedTranslations);
    return getTranslationProvider(translations, local);
}

function convertTranslationsToJSON(translations, useId) {
    const xmlTranslation = translations;
    if (!xmlTranslation) {
        return;
    }

    const translationUnits = xmlTranslation.documentElement.getElementsByTagName('trans-unit');
    const output = {};
    for (let i = 0; i < translationUnits.length; i++) {
        const id = translationUnits[i].getAttribute('id');
        let source = translationUnits[i].getElementsByTagName('source')[0];
        let target = translationUnits[i].getElementsByTagName('target')[0];
        source = source.firstChild ? source.firstChild.nodeValue : source.nodeValue;
        target = (target) ? createJSONValue(target, useId) : null;
        output[id] = {
            source,
            target
        };
    }
    return output;
}

function trimValues(target){
    if(target.childNodes){
        target.childNodes.forEach((current, index) => {
            // remove linebreaks before child elements
            if(target.childNodes[index + 1] && target.childNodes[index + 1].nodeType === 1 && current && current.nodeValue){
                if(~current.nodeValue.lastIndexOf('\r\n') && !current.nodeValue.substring(current.nodeValue.lastIndexOf('\r\n'), current.nodeValue.length).trim()){
                    current.nodeValue = current.nodeValue.substring(0, current.nodeValue.lastIndexOf('\r\n'));
                }else if(~current.nodeValue.lastIndexOf('\n') && !current.nodeValue.substring(current.nodeValue.lastIndexOf('\n'), current.nodeValue.length).trim()){
                    current.nodeValue = current.nodeValue.substring(0, current.nodeValue.lastIndexOf('\n'));
                }
            }
        })
    }
}

function createJSONValue(target, useId = false){
    if(target && target.firstChild){
        let output = '';
        if(target.childNodes.length === 1){
            return target.firstChild.nodeValue;
        }
        trimValues(target);
        target.childNodes.forEach((current) => {
            if(current.nodeType === 1 && current.nodeName.toLowerCase() === 'x'){
                if(useId){
                    let name =  current.getAttribute('id').replace(/[\{|\}]/gm, '');
                    name = name.replace(/\-/gm, '_');
                    output += '{$' + name + '}';
                }else{
                    output += '{$' + current.getAttribute('equiv-text').replace(/[\{|\}]/gm, '') + '}'
                }
            }else{
                output += current.nodeValue.replace(/(\r\n|\n|\r)/gm, '');
            }
        })
        output = output.replace(/\n/gm, '');
        return output;
    }
    return target.nodeValue;
}


export function loadExternalTranslations(translations) {
    const win = window as any;
    const translationsJson = convertTranslationsToJSON(translations, false);
    win.JS_TRANSLATIONS = translationsJson;
    const normalTranslations = convertTranslationsToJSON(translations, true);
    const keyValueFormat = {};
    Object.keys(normalTranslations).forEach((current) => {
        if(normalTranslations[current].target){
            keyValueFormat[current] = normalTranslations[current].target;
        }
    });
    loadTranslations(keyValueFormat);
}



export function getTranslationProviders() {
    return new Promise((resolve, reject) => {
        console.time('load languages');
        Promise.all([xlfTranslationProvider()]).then((result) => {
            let output: Array<any> = [];
            output = result.map((current) => output.concat(current));
            console.timeEnd('load languages');
            resolve(output);
        });
    });
}
